(function () {
  function parseJsonScript(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error("[product-v3] Failed to parse JSON:", error);
      return null;
    }
  }

  function initQuantity(root) {
    var input = root.querySelector("[data-qty-input]");
    var minus = root.querySelector("[data-qty-minus]");
    var plus = root.querySelector("[data-qty-plus]");
    if (!input || !minus || !plus) return;

    function getValue() {
      return Math.max(1, parseInt(input.value, 10) || 1);
    }

    function syncButtons() {
      minus.disabled = getValue() <= 1;
    }

    function applyValue(next, emitChange) {
      input.value = String(Math.max(1, next));
      syncButtons();
      if (emitChange) input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    minus.addEventListener("click", function () {
      if (getValue() <= 1) return;
      applyValue(getValue() - 1, true);
    });

    plus.addEventListener("click", function () {
      applyValue(getValue() + 1, true);
    });

    input.addEventListener("input", function () {
      input.value = input.value.replace(/[^\d]/g, "");
      syncButtons();
    });

    input.addEventListener("change", function () {
      applyValue(getValue(), false);
    });

    input.addEventListener("blur", function () {
      applyValue(getValue(), false);
    });

    syncButtons();
  }

  function cartRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
  }

  function sectionQuantity(sectionRoot) {
    var qtyInput = sectionRoot.querySelector("[data-qty-input]");
    return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
  }

  function shakeAfterScroll(item) {
    var scroller = document.scrollingElement || document.documentElement;
    var lastTop = scroller.scrollTop;
    var moved = false;
    var stableFrames = 0;
    var frames = 0;

    function shake() {
      item.classList.remove("is-attention");
      void item.offsetWidth;
      item.classList.add("is-attention");
    }

    function tick() {
      var top = scroller.scrollTop;
      var delta = Math.abs(top - lastTop);
      lastTop = top;
      frames += 1;
      if (delta >= 1) {
        moved = true;
        stableFrames = 0;
      } else if (moved) {
        stableFrames += 1;
      }
      if ((moved && stableFrames >= 6) || (!moved && frames >= 10) || frames >= 120) {
        shake();
        return;
      }
      window.requestAnimationFrame(tick);
    }

    window.requestAnimationFrame(tick);
  }

  function flagAddonPending(item) {
    if (!item) return;
    item.classList.remove("is-attention");
    var dropdown = item.querySelector("[data-acc-dropdown]");
    var toggle = item.querySelector("[data-acc-toggle]");
    var menu = item.querySelector("[data-acc-menu]");
    if (dropdown) dropdown.classList.add("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
    if (menu) menu.hidden = false;
    item.scrollIntoView({ behavior: "smooth", block: "center" });
    shakeAfterScroll(item);
  }

  function collectAddons(sectionRoot) {
    var ids = [];
    var pending = null;

    var bundleRoot = sectionRoot.querySelector("[data-product-v3-bundle]");
    if (bundleRoot) {
      var bundleItem = bundleRoot.querySelector("[data-bundle-item].is-selected");
      var noneSelected = bundleRoot.querySelector("[data-bundle-none].is-selected");
      if (bundleItem) {
        var bundleId = bundleItem.getAttribute("data-selected-variant");
        if (bundleId) ids.push(bundleId);
        else pending = bundleItem;
      } else if (bundleRoot.hasAttribute("data-bundle-required") && !noneSelected) {
        pending = bundleRoot;
      }
    }

    sectionRoot.querySelectorAll("[data-accessory-item].is-checked").forEach(function (item) {
      var accessoryId = item.getAttribute("data-selected-variant");
      if (accessoryId) ids.push(accessoryId);
      else if (!pending) pending = item;
    });

    return { ids: ids, pending: pending };
  }

  function clearAccessorySelection(sectionRoot) {
    sectionRoot.querySelectorAll("[data-accessory-item].is-checked").forEach(function (item) {
      var check = item.querySelector("[data-acc-check]");
      if (check) check.checked = false;
      item.classList.remove("is-checked", "is-attention");
      var dropdown = item.querySelector("[data-acc-dropdown]");
      if (!dropdown) return;
      dropdown.classList.remove("is-open");
      var toggle = dropdown.querySelector("[data-acc-toggle]");
      var menu = dropdown.querySelector("[data-acc-menu]");
      var label = dropdown.querySelector("[data-acc-label]");
      var price = item.querySelector("[data-acc-price]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      if (menu) menu.hidden = true;
      var defaultId = item.getAttribute("data-default-variant") || "";
      var defaultCents = item.getAttribute("data-default-price-cents") || "";
      dropdown.querySelectorAll("[data-acc-option]").forEach(function (option) {
        option.classList.toggle("is-selected", option.getAttribute("data-variant-id") === defaultId);
      });
      if (defaultId) item.setAttribute("data-selected-variant", defaultId);
      else item.removeAttribute("data-selected-variant");
      if (defaultCents) item.setAttribute("data-price-cents", defaultCents);
      else item.removeAttribute("data-price-cents");
      if (label) label.textContent = label.getAttribute("data-default-label") || "";
      if (price) price.textContent = price.getAttribute("data-default-price") || price.textContent;
      var compare = item.querySelector("[data-acc-compare]");
      if (compare) {
        var defaultCompare = compare.getAttribute("data-default-compare") || "";
        compare.textContent = defaultCompare;
        compare.hidden = !defaultCompare;
      }
      var image = item.querySelector("[data-acc-image]");
      if (image && image.getAttribute("data-default-src")) {
        image.setAttribute("src", image.getAttribute("data-default-src"));
        image.setAttribute("alt", image.getAttribute("data-default-alt") || "");
      }
      var badge = item.querySelector("[data-acc-badge]");
      if (badge) {
        var defaultBadge = badge.getAttribute("data-default-badge") || "";
        badge.textContent = defaultBadge;
        badge.hidden = !defaultBadge;
        item.classList.toggle("pv3-acc__item--badge", !!defaultBadge);
      }
    });
    updatePurchaseSummary(sectionRoot);
  }

  function purchaseButtons(sectionRoot, kind) {
    var selector = kind === "buy-now"
      ? "[data-buy-now]"
      : "[data-add-to-cart], [data-sticky-add-to-cart]";
    return sectionRoot.querySelectorAll(selector);
  }

  function setPurchaseLoading(sectionRoot, kind, loading) {
    purchaseButtons(sectionRoot, kind).forEach(function (button) {
      button.classList.toggle("is-loading", loading);
      button.setAttribute("aria-busy", loading ? "true" : "false");
    });
  }

  function isPurchaseLoading(sectionRoot, kind) {
    return Array.prototype.some.call(purchaseButtons(sectionRoot, kind), function (button) {
      return button.classList.contains("is-loading");
    });
  }

  function clearPurchaseLoading(sectionRoot) {
    setPurchaseLoading(sectionRoot, "atc", false);
    setPurchaseLoading(sectionRoot, "buy-now", false);
  }

  function clearAllPurchaseLoading() {
    document.querySelectorAll("[data-product-v3]").forEach(clearPurchaseLoading);
  }

  function addAddonItems(mainId, addonIds, quantity) {
    var items = [{ id: Number(mainId), quantity: quantity }];
    addonIds.forEach(function (id) {
      items.push({ id: Number(id), quantity: quantity });
    });
    return fetch(cartRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          var message = (data && (data.description || data.message)) || "";
          if (typeof window.showNotice === "function") window.showNotice("error", message);
        });
      }
      document.documentElement.dispatchEvent(new CustomEvent("cart:reRequest", { bubbles: true, detail: {} }));
      if (typeof window.showNotice === "function") window.showNotice();
      return true;
    }).catch(function () {
      if (typeof window.showNotice === "function") window.showNotice("error", "");
      return false;
    });
  }

  function initBuyNow(sectionRoot) {
    var variantInput = sectionRoot.querySelector("[data-variant-input]");
    if (!variantInput) return;

    sectionRoot.querySelectorAll("[data-buy-now]").forEach(function (buyNowBtn) {
      buyNowBtn.addEventListener("click", function (event) {
        event.preventDefault();
        if (buyNowBtn.disabled || isPurchaseLoading(sectionRoot, "buy-now")) return;
        var addons = collectAddons(sectionRoot);
        if (addons.pending) {
          flagAddonPending(addons.pending);
          return;
        }
        var variantId = variantInput.value;
        var quantity = sectionQuantity(sectionRoot);
        if (!variantId) return;
        var parts = [variantId + ":" + quantity];
        addons.ids.forEach(function (id) {
          parts.push(id + ":" + quantity);
        });
        setPurchaseLoading(sectionRoot, "buy-now", true);
        clearAccessorySelection(sectionRoot);
        var checkoutUrl = cartRoot() + "cart/" + parts.join(",") + "?checkout";
        var discountNode = sectionRoot.querySelector("[data-checkout-discount]");
        var discountCode = discountNode ? String(discountNode.getAttribute("data-checkout-discount") || "").trim() : "";
        if (discountCode) checkoutUrl += "&discount=" + encodeURIComponent(discountCode);
        window.location.href = checkoutUrl;
      });
    });

    sectionRoot.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches("form[action*='/cart/add'], form[is='product-form']")) return;
      if (isPurchaseLoading(sectionRoot, "atc")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      var addons = collectAddons(sectionRoot);
      if (addons.pending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        flagAddonPending(addons.pending);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!variantInput.value) return;
      setPurchaseLoading(sectionRoot, "atc", true);
      addAddonItems(variantInput.value, addons.ids, sectionQuantity(sectionRoot)).then(function (added) {
        if (added) clearAccessorySelection(sectionRoot);
      }).then(function () {
        clearPurchaseLoading(sectionRoot);
      }, function () {
        clearPurchaseLoading(sectionRoot);
      });
    }, true);
  }

  function bundleVariantPrice(item) {
    var variantId = item.getAttribute("data-selected-variant");
    var raw = item.querySelector("[data-bundle-json]");
    if (!variantId || !raw) return 0;
    var variants = [];
    try { variants = JSON.parse(raw.textContent) || []; } catch (error) { variants = []; }
    var match = variants.find(function (variant) { return String(variant.id) === String(variantId); });
    return match && match.price ? Number(match.price) : 0;
  }

  function updatePurchaseSummary(sectionRoot) {
    var summary = sectionRoot.querySelector("[data-selection-summary]");
    var variantData = sectionRoot._pv3VariantData;
    if (!summary || !variantData) return;
    var input = sectionRoot.querySelector("[data-variant-input]");
    var variant = (variantData.variants || []).find(function (item) {
      return String(item.id) === String(input && input.value);
    });
    if (!variant) return;

    var qty = sectionQuantity(sectionRoot);
    var cents = Number(variant.price) * qty;

    sectionRoot.querySelectorAll("[data-accessory-item].is-checked").forEach(function (item) {
      var price = Number(item.getAttribute("data-price-cents"));
      if (item.getAttribute("data-selected-variant") && price) cents += price * qty;
    });

    var bundleRoot = sectionRoot.querySelector("[data-product-v3-bundle]");
    if (bundleRoot && bundleRoot.hasAttribute("data-bundle-add-price")) {
      var bundleItem = bundleRoot.querySelector("[data-bundle-item].is-selected");
      if (bundleItem) cents += bundleVariantPrice(bundleItem) * qty;
    }

    var priceText = formatMoney(cents, variantData.moneyFormat);
    sectionRoot.querySelectorAll("[data-product-v3-buy-price], [data-product-v3-sticky-price]").forEach(function (el) {
      el.textContent = priceText;
    });
  }

  function updateStickyNote(sectionRoot, priceFormatted) {
    var noteEl = sectionRoot.querySelector("[data-product-v3-sticky-note]");
    if (!noteEl) return;
    var template = noteEl.getAttribute("data-note-template") || "";
    if (!template) return;
    noteEl.textContent = template.split("{{price}}").join(priceFormatted || "");
  }

  function formatMoney(cents, format) {
    var template = String(format || "${{amount}}").replace(/<[^>]*>/g, "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      var amount = (number / 100).toFixed(precision);
      var parts = amount.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var token = (template.match(placeholder) || [])[1];
    var value = withDelimiters(cents, 2, ",", ".");
    if (token === "amount_no_decimals") value = withDelimiters(cents, 0, ",", ".");
    else if (token === "amount_with_comma_separator") value = withDelimiters(cents, 2, ".", ",");
    else if (token === "amount_no_decimals_with_comma_separator") value = withDelimiters(cents, 0, ".", ",");
    else if (token === "amount_with_apostrophe_separator") value = withDelimiters(cents, 2, "'", ".");
    return template.replace(placeholder, value).replace(/([.,]00)(?!\d)/, "");
  }

  function initVariantPicker(sectionRoot, variantData) {
    sectionRoot._pv3VariantData = variantData || null;
    var optionsWrap = sectionRoot.querySelector("[data-variant-options]");
    var variantInput = sectionRoot.querySelector("[data-variant-input]");
    var skuEl = sectionRoot.querySelector("[data-product-v3-sku]");
    var inventoryEl = sectionRoot.querySelector("[data-product-v3-inventory]");
    var form = sectionRoot.querySelector(
      "form[is='product-form'], form.product-form, form[action*='/cart/add']"
    );
    if (!optionsWrap || !variantInput || !variantData) return;
    var hideSoldOut = optionsWrap.hasAttribute("data-hide-sold-out");

    function findByOptions(options) {
      return (variantData.variants || []).find(function (variant) {
        var values = variant.options || [];
        return options.every(function (value, index) {
          return values[index] === value;
        });
      });
    }

    function refreshOptions(variant) {
      var selected = variant.options || [];
      optionsWrap.querySelectorAll("[data-option-group]").forEach(function (group) {
        var index = Number(group.getAttribute("data-option-index"));
        var buttons = group.querySelectorAll("[data-option-value]");
        var minPrice = null;
        buttons.forEach(function (button) {
          var nextOptions = selected.slice();
          nextOptions[index] = button.getAttribute("data-option-value");
          var match = findByOptions(nextOptions);
          if (match && (minPrice === null || match.price < minPrice)) minPrice = match.price;
        });
        buttons.forEach(function (button) {
          var value = button.getAttribute("data-option-value");
          var nextOptions = selected.slice();
          nextOptions[index] = value;
          var match = findByOptions(nextOptions);
          var isSelected = value === selected[index];
          var unavailable = !match || !match.available;
          button.classList.toggle("is-selected", isSelected);
          button.classList.toggle("is-disabled", unavailable);
          button.setAttribute("aria-pressed", isSelected ? "true" : "false");
          button.hidden = hideSoldOut && unavailable && !isSelected;
          button.disabled = unavailable && !isSelected;
          var priceEl = button.querySelector("[data-option-price]");
          if (!priceEl) return;
          var delta = match && minPrice !== null ? match.price - minPrice : 0;
          priceEl.textContent = delta > 0 ? "+" + formatMoney(delta, variantData.moneyFormat) : "";
        });
      });
      var initialNotes = optionsWrap.getAttribute("data-notes-ready") !== "1";
      optionsWrap.setAttribute("data-notes-ready", "1");
      optionsWrap.querySelectorAll("[data-option-note]").forEach(function (note) {
        var group = note.closest("[data-option-group]");
        var selected = group && group.querySelector("[data-option-value].is-selected");
        var current = selected ? (selected.getAttribute("data-option-value") || "").trim().toLowerCase() : "";
        var trigger = (note.getAttribute("data-note-value") || "").trim().toLowerCase();
        var show = Boolean(trigger && current.indexOf(trigger) !== -1);
        if (show) {
          if (initialNotes || (!note.hidden && note.classList.contains("is-shown") && !note.classList.contains("is-hiding"))) {
            note.hidden = false;
            note.classList.remove("is-hiding");
            note.classList.add("is-shown");
            return;
          }
          note.hidden = false;
          note.classList.remove("is-hiding", "is-shown");
          void note.offsetWidth;
          note.classList.add("is-shown");
          return;
        }
        if (initialNotes || note.hidden) {
          note.hidden = true;
          note.classList.remove("is-shown", "is-hiding");
          return;
        }
        note.classList.remove("is-shown");
        note.classList.add("is-hiding");
        var finish = function () {
          note.removeEventListener("animationend", finish);
          if (!note.classList.contains("is-hiding")) return;
          note.hidden = true;
          note.classList.remove("is-hiding");
        };
        note.addEventListener("animationend", finish);
      });
    }

    function selectVariant(variantId) {
      var variant = variantData.variants.find(function (item) {
        return item.id === variantId;
      });
      if (!variant) return;

      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      refreshOptions(variant);

      sectionRoot.querySelectorAll("[data-product-v3-price]").forEach(function (el) {
        if (variant.priceFormatted) el.textContent = variant.priceFormatted;
      });

      if (!sectionRoot.querySelector("[data-selection-summary]")) {
        var stickyPrice = sectionRoot.querySelector("[data-product-v3-sticky-price]");
        if (stickyPrice && variant.priceFormatted) stickyPrice.textContent = variant.priceFormatted;
      }
      updateStickyNote(sectionRoot, variant.priceFormatted || "");
      updatePurchaseSummary(sectionRoot);

      var comparePriceEl = sectionRoot.querySelector("[data-product-v3-compare-price]");
      if (comparePriceEl) {
        var allowCompare = comparePriceEl.getAttribute("data-show-compare") !== "false";
        var hasCompare = allowCompare && Number(variant.compareAtPrice) > Number(variant.price);
        comparePriceEl.hidden = !hasCompare;
        comparePriceEl.textContent = hasCompare
          ? variant.compareAtPriceFormatted || ""
          : "";
      }

      if (skuEl) {
        skuEl.textContent = variant.sku || skuEl.getAttribute("data-empty-text") || "N/A";
      }

      if (inventoryEl) {
        var stockText = inventoryEl.getAttribute("data-in-stock-text") || "In stock";
        var soldOutText = inventoryEl.getAttribute("data-sold-out-text") || "Sold out";
        var showQty = inventoryEl.getAttribute("data-show-quantity") === "true";
        inventoryEl.textContent = variant.available
          ? stockText + (showQty ? " (" + variant.inventory + ")" : "")
          : soldOutText;
      }

      sectionRoot
        .querySelectorAll(
          "[data-add-to-cart], [data-buy-now], [data-sticky-add-to-cart], [data-sticky-payment]"
        )
        .forEach(function (btn) {
          btn.disabled = !variant.available;
        });

      if (form) {
        form.dispatchEvent(
          new CustomEvent("variant:changed", {
            bubbles: true,
            detail: { variant: variant },
          })
        );
      }

      if (history.replaceState) {
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", String(variant.id));
        window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
      }
    }

    optionsWrap.addEventListener("click", function (event) {
      var button = event.target.closest("[data-option-value]");
      if (!button || button.disabled) return;
      var group = button.closest("[data-option-group]");
      if (!group) return;
      var index = Number(group.getAttribute("data-option-index"));
      var options = [];
      optionsWrap.querySelectorAll("[data-option-group]").forEach(function (item) {
        var active = item.querySelector(".is-selected");
        options[Number(item.getAttribute("data-option-index"))] = active
          ? active.getAttribute("data-option-value")
          : "";
      });
      options[index] = button.getAttribute("data-option-value");
      var match = findByOptions(options);
      if (!match) {
        match = (variantData.variants || []).find(function (variant) {
          return (variant.options || [])[index] === button.getAttribute("data-option-value");
        });
      }
      if (match) selectVariant(match.id);
    });

    var current = (variantData.variants || []).find(function (variant) {
      return String(variant.id) === String(variantInput.value);
    });
    if (current) refreshOptions(current);
  }

  window.addEventListener("pagehide", clearAllPurchaseLoading);
  window.addEventListener("pageshow", clearAllPurchaseLoading);

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-product-v3]").forEach(function (sectionRoot) {
      var galleryRoot = sectionRoot.querySelector("[data-product-v3-gallery]");
      var imageData = parseJsonScript(sectionRoot.getAttribute("data-images-script-id"));
      var variantData = parseJsonScript(sectionRoot.getAttribute("data-variants-script-id"));

      if (galleryRoot && imageData && window.ProductV3Gallery) {
        new window.ProductV3Gallery(galleryRoot, imageData);
      }

      initQuantity(sectionRoot);
      initBuyNow(sectionRoot);
      initVariantPicker(sectionRoot, variantData);
      updatePurchaseSummary(sectionRoot);
      sectionRoot.addEventListener("click", function () {
        updatePurchaseSummary(sectionRoot);
      });
      sectionRoot.addEventListener("change", function () {
        updatePurchaseSummary(sectionRoot);
      });
    });
  });
})();
